module.exports = __webpack_public_path__ + "/img/Header-Female-Right-Angle-CpZFu5.svg";